var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.44453C0 5.59708 0 4.17335 0.562933 3.08966C1.03731 2.17644 1.78191 1.43184 2.69513 0.957464C3.77882 0.394531 5.20255 0.394531 8.05 0.394531H15.95C18.7975 0.394531 20.2212 0.394531 21.3049 0.957464C22.2181 1.43184 22.9627 2.17644 23.4371 3.08966C24 4.17335 24 5.59708 24 8.44453V16.3445C24 19.192 24 20.6157 23.4371 21.6994C22.9627 22.6126 22.2181 23.3572 21.3049 23.8316C20.2212 24.3945 18.7975 24.3945 15.95 24.3945H8.05C5.20255 24.3945 3.77882 24.3945 2.69513 23.8316C1.78191 23.3572 1.03731 22.6126 0.562933 21.6994C0 20.6157 0 19.192 0 16.3445V8.44453Z",
    fill: "#1265BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38668 7.84758C6.53654 7.84758 7.46868 6.91544 7.46868 5.76559C7.46868 4.61573 6.53654 3.68359 5.38668 3.68359C4.23683 3.68359 3.30469 4.61573 3.30469 5.76559C3.30469 6.91544 4.23683 7.84758 5.38668 7.84758Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37543 9.38624H12.826V10.967C12.826 10.967 13.7623 9.09425 16.31 9.09425C18.5826 9.09425 20.4653 10.2138 20.4653 13.6263V20.8223H16.8895V14.4983C16.8895 12.4852 15.8148 12.2638 14.9959 12.2638C13.2963 12.2638 13.0053 13.7298 13.0053 14.7608V20.8223H9.37543V9.38624Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57176 9.38624H7.20161V20.8223H3.57176V9.38624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.742fd7d1400f7ce24d71c157a415a5e7.svg";
export { ForwardRef as ReactComponent };